import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { MultiSelectCombobox } from '../../../legacy-design-system/combobox'

function AngularMultiSelectCombobox(props) {
  return <MultiSelectCombobox {...props} />
}

export const reactMultiselectCombobox = createNgReactBridgeDirective(
  'reactMultiselectCombobox',
  [],
  AngularMultiSelectCombobox,
  ['items', 'onChange', 'values', 'itemToString', 'placeholder']
)
